import React from 'react';
import { Breadcrumb, Container } from 'react-bootstrap';
import vdom from '../../../../images/blogs/vdom.png'

const ReactDomDetails = () => {
    return (
        <div>
            <div className='fs-2 text-white ps-5 pt-5' style={{ 'height': '180px', 'backgroundColor': '#000000' }}>
                <Breadcrumb>
                    <Breadcrumb.Item href="/blogs" >Blog</Breadcrumb.Item>

                    <Breadcrumb.Item active>React Virtual DOM</Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <Container className='bg-white'>

                <div className='w-75 mx-auto  text-start text-dark pb-5'>
                    <h2 className='fw-bold py-4'>React Virtual DOM</h2>
                    <p>
                        DOM stands for “Document Object Model”.It is a programming interface for web documents. It basically represents the page so that programmer can change the document structure, style, and content. The DOM represents the document as nodes and objects and this is the way how programming language can interact with the web pages.
                        <br /> <br />
                        <strong>Virtual DOM</strong> is just a copy of real DOM. Virtual dom is a programming concept. It is an in-memory representation of Real DOM. It is where the representation of UI is kept in mind and makes synchronization with Real DOM. And these steps happen when the render function is called and elements are displayed on the screen. The full process is called reconciliation.

                    </p>
                    <h5 className='fw-bold mb-3'>How do Virtual DOM works?
                    </h5>
                    <p>If there is an update in VDOM, It compares the previous code with the updated one. With this comparison React figures out which component in UI should get updated. This process is called “diffing”.In diffing process, an algorithm is used this algorithm is called a diffing algorithm.</p>
                    <img src={vdom} alt="" className='img-fluid' style={{ width: "550px" }} />

                    <p>When there is an update in the UI A VDOM is represented as a tree is created and each element is a node on the tree. If any of these elements change their state Virtual Dom calculates the best possible way to make a change in Real DOM.
                        The Red circle contains the node that has changed its state. These nodes represent the elements that have had their state changed.
                        So the difference between the previous Virtual DOM Tree and the current tree is being calculated. The whole parent subtree then gets re-rendered to give the updated UI. And then this updated tree is then batch updated to the real DOM.
                    </p>

                </div>
            </Container>
        </div>
    );
};

export default ReactDomDetails;